<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="contacts-block">
        <div v-for="{icon, data, type, hint, link} in contacts" :key="data" class="contact-wrapper">
          <div class="contact">
            <component :is="icon" class="contact__icon"/>
            <app-phone-link v-if="type === types.phone" :phone-number="data" class="contact__link"/>
            <app-email-link v-if="type === types.email" :email="data" class="contact__link"/>
            <a v-else-if="type === types.link" :href="link" target="_blank" class="contact__link">{{ data }}</a>
            <span v-else-if="!type" class="contact__link">{{ data }}</span>
          </div>
          <span v-if="hint" class="contact__text">{{ hint }}</span>
        </div>
      </div>

      <footer-menu/>
    </div>


    <div class="license">
      <div v-if="showTerms" class="sf-mb-s">
        {{ $t('footer.terms') }}
      </div>

      © {{ currentYear }}&nbsp;{{ $t('layout.name') }}&nbsp;{{ $t('footer.license') }}
    </div>
  </footer>
</template>

<script>
import Clock from '~/static/img/contacts/mdi-clock.svg';
import Mail from '~/static/img/contacts/email.svg';
import Phone from '~/static/img/contacts/phone-in-talk.svg';
import YouTube from '~/static/img/icons/youtube.svg';
import FooterMenu from '~/components/footer/footer-menu';
import AppPhoneLink from '~/components/links/phone-link.vue';
import AppEmailLink from '~/components/links/email-link.vue';

export default {
  components: { AppEmailLink, AppPhoneLink, FooterMenu, Clock },
  data: () => ({
    currentYear: new Date().getFullYear(),
    types: {
      phone: 'phone',
      email: 'email',
      link: 'link',
    },
  }),
  computed: {
    showTerms() {
      return !this.$route.name.includes('landing-ga');
    },

    contacts() {
      return [
        {
          icon: Phone,
          data: this.$t('contacts-page.tel-cc1'),
          type: this.types.phone,
        },
        {
          icon: Phone,
          data: this.$t('contacts-page.tel-cc2'),
          type: this.types.phone,
        },
        {
          icon: Phone,
          data: this.$t('contacts-page.tel-cc3'),
          type: this.types.phone,
        },
        {
          icon: Mail,
          data: this.$t('contacts-page.email-cc'),
          type: this.types.email,
        },
        {
          icon: Clock,
          data: this.$t('contacts-page.hours'),
          type: null,
        },
        {
          icon: Mail,
          data: this.$t('contacts-page.email-complains'),
          hint: this.$t('contacts-page.email-complains-title'),
          type: this.types.email,
        },
        {
          icon: YouTube,
          data: 'YouTube',
          type: this.types.link,
          link: 'https://youtube.com/@finokg_official?si=ON8YweH0VbReJ7nj',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: map-get($colors, gray-darker);

  &__container {
    padding: 40px 20px;

    @include mobile {
      padding-bottom: 0;
    }

    @include tablet {
      @include contentGrid;
      display: flex;
      justify-content: space-between;
    }
  }

  & /deep/ .toggle {
    @include tablet {
      height: auto !important;
    }
  }
}

.contacts-block {
  @include mobile {
    @include contentGrid;
    padding-bottom: 40px;
  }

  @include tablet {
    width: 50%;
    border-bottom: none;
  }
}

.contact {
  display: flex;
  align-items: center;

  &-wrapper:not(:last-child) {
    margin-bottom: 20px;
  }

  &__icon {
    @include square(24px);
    margin-right: 16px;
    fill: map-get($colors, secondary);
    color: map-get($colors, secondary);
  }

  &__link {
    color: map-get($colors, white);
    font-weight: 500;
  }

  &__text {
    color: #fff;
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
    display: block;
    max-width: 113px;
    margin-left: 40px;
  }
}

.license {
  font-size: 12px;
  line-height: 24px;
  padding: 32px;
  text-align: center;
  color: map-get($colors, background);
  opacity: 0.8;
  border-top: 1px solid #5d5c5c;
  @include contentGrid;

  @include mobile {
    padding: 16px;
  }
}
</style>
